/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedExportToolListResponse } from '../types/PaginatedExportToolList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type ExportToolsListRequest = {} | null | undefined;
export type ExportToolsListResponse = PaginatedExportToolListResponse;

export type ExportToolsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: format
   * schema:
   *   type: integer
   * ```
   */
  format?: number;

  /**
   * ```yaml
   * in: query
   * name: is_package
   * schema:
   *   type: boolean
   * ```
   */
  is_package?: boolean;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/export_tools/
 *
 * ```yaml
 * operationId: export_tools_list
 * tags:
 *   - export_tools
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedExportToolList'
 *     description: ''
 * ```
 */
export const exportToolsListOperation = (rest?: ExportToolsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/export_tools/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/export_tools/' };
  };

/**
 * GET /dmx-server/export_tools/
 *
 * ```yaml
 * operationId: export_tools_list
 * tags:
 *   - export_tools
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedExportToolList'
 *     description: ''
 * ```
 */
export const exportToolsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: ExportToolsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedExportToolListResponse>> => {
  const operation = exportToolsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/export_tools/
 */
export const useExportToolsListResource = (
  query: ExportToolsListQuery | null,
  useCached?: boolean,
): UseResource<ExportToolsListResponse> => {
  return useResource<ExportToolsListResponse>({
    path: query === null ? null : exportToolsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
